//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import angular from 'angular';
import React from 'react';

import makeAngularReactController from '@react-bridge/angular-react-widget';
import EditableStreamName from '@streams/components/EditableStreamName';

angular.module('curalate').component('editableStreamName', {
  controller: makeAngularReactController(<EditableStreamName/>),
});
